module.exports = __webpack_public_path__ + "img/images-02.a7f99d61.png";